import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Column, Container, List, Row } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { isValidArray } from '../../utilities/validations';

const HeroSimple = ({ data, className, ...other }) => (
	<div
		className={`heroSimple relative md:mb-12 lg:mb-16 2xl:mb-20 ${className || ''}`}
		data-testid='hero-simple'
		{...other}
	>
		<Container className='max-md:!px-0 md:!pr-0'>
			<Row
				align='center'
				reverse
				noGutters
			>
				<Column
					xs={12}
					md={7}
				>
					{isValidArray(data.image) && (
						<Image
							data={data.image[0]}
							className='!block aspect-[2.5/1] w-full md:aspect-[1.75]'
							loading='eager'
						/>
					)}
				</Column>

				<Column
					xs={12}
					md='fluid'
				>
					<div className='px-6 pb-9 pt-6 md:pl-0 md:pr-8 xl:pr-12'>
						{data.icon?.url && <Image data={{ image: data.icon, image_alt: '' }} />}

						{data.badge && (
							<Badge
								dangerouslySetInnerHTML={{ __html: data.badge }}
								className='mb-2 md:mb-3 [&>span:first-child]:!text-sm md:[&>span:first-child]:!text-lg'
								size='md'
							/>
						)}
						{data.heading && <h1 className='mb-2.5 text-pretty'>{data.heading}</h1>}
						{data.description && (
							<div
								className='text-pretty'
								dangerouslySetInnerHTML={{ __html: data.description }}
							/>
						)}
						{data.disclaimer && <p className='text-caption mb-2.5 mt-7 uppercase text-gray-55'>{data.disclaimer}</p>}

						{isValidArray(data.ctas) && (
							<List
								bullets='none'
								className='mt-5 flex space-x-2.5'
							>
								{data.ctas.map((link, index) => (
									<li
										key={index}
										className='my-1 flex-initial [&_a]:!no-underline'
									>
										<CTA
											data={link}
											className='!w-auto flex-row-reverse gap-x-2 !text-left [&_span]:!mr-0'
										/>
									</li>
								))}
							</List>
						)}
					</div>
				</Column>
			</Row>
		</Container>
	</div>
);

HeroSimple.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default HeroSimple;
